module.exports = __webpack_public_path__ + "img/17-5-14.a21d6a4f.jpg";